<span
  class="FormGroupArrayTitle"
  [style.font-size]="
    config.titleSize ? 'var(--' + config.titleSize + '-font-size)' : 'inherit'
  "
  [style.line-height]="
    config.titleSize ? 'var(--' + config.titleSize + '-line-height)' : 'inherit'
  "
>
  {{ config.title }}
  @if (formArray.controls.length > 1) {
    <span>#{{ index + 1 }}</span>
  }
</span>
